import { NullDictionaryDefinition } from "../../stores/dictionary/NullDictionaryDefinition";
import { Word } from "../../stores/word/Word";

export namespace WordCsvParser {
  export function parseWordCsvLineFromCsvFile(csvLine: string): Word {
    const cells = csvLine.split(",").map((cell) => cell.trim());
    if (cells.length === 0) {
      throw new Error("CSV line has no cells!");
    }

    let cell = 0;
    const wordName = cells[cell++];
    const wordRecord = new Word(wordName);

    wordRecord.originalLanguage = cells[cell++];
    wordRecord.originalWord = cells[cell++];
    wordRecord.dictionaryUrl = cells[cell++];
    wordRecord.imageUrl = cells[cell++];
    wordRecord.city = cells[cell++];
    wordRecord.country = cells[cell++];
    wordRecord.notes = cells[cell++];
    wordRecord.wordType = cells[cell++];
    wordRecord.definition = new NullDictionaryDefinition(wordName);

    return wordRecord;
  }

  const ORIGINAL_LANGUAGE_INDEX = 0;
  const ORIGINAL_WORD_INDEX = 1;
  const DICTIONARY_INDEX = 2;
  const IMAGE_INDEX = 3;
  const CITY_INDEX = 4;
  const COUNTRY_INDEX = 5;
  const NOTES_INDEX = 6;
  const WORD_TYPE_INDEX = 7;

  export function parseWordCsvLineFromGoogleSheets(
    wordName: string,
    values: string[]
  ): Word {
    // parse/split the content into an object
    /* example:
        originallanguage: Afrikaans,
        originalword: apartheid,
        dictionary: http://oxforddictionaries.com/definition/english/apartheid,
        image: http://loremflickr.com/150/150/apartheid,
        city: Cape Town,
        country: South Africa
        */
    // note: GoogleSheets splits the 1st column ('loanWord' === wordName)

    wordName = wordName.trim();

    const wordRecord = new Word(wordName);
    wordRecord.originalLanguage = "";
    wordRecord.originalWord = "";
    wordRecord.dictionaryUrl = "";
    wordRecord.imageUrl = "";
    wordRecord.city = "";
    wordRecord.country = "";
    wordRecord.wordType = "";
    wordRecord.definition = new NullDictionaryDefinition(wordName);

    wordRecord.originalLanguage = values[ORIGINAL_LANGUAGE_INDEX] || "";
    wordRecord.originalWord = values[ORIGINAL_WORD_INDEX] || "";
    wordRecord.dictionaryUrl = values[DICTIONARY_INDEX] || "";
    wordRecord.imageUrl = values[IMAGE_INDEX] || "";
    wordRecord.city = values[CITY_INDEX] || "";
    wordRecord.country = values[COUNTRY_INDEX] || "";
    wordRecord.notes = values[NOTES_INDEX] || "";
    wordRecord.wordType = values[WORD_TYPE_INDEX] || "";

    return wordRecord;
  }
}



// WEBPACK FOOTER //
// ./services/word/WordCsvParser.ts